import { createBrowserRouter, RouteObject } from "react-router-dom";
import { roleGuard } from "./RoleGuard";
import PrivateRoutes from "./PrivateRoute";
// import Index from '../pages/Index';
import Login from "../pages/Login/Login";
import Profile from "../pages/Profile/Profile";
import NotFound from "../pages/NotFound/NotFound";
import Register from "../pages/Register/Register";
import EditProfile from "../pages/Profile/EditProfile";
import ResetPassword from "../pages/ResetPassword/ResetPassword";
import CourseView from "../pages/Course/CourseView";
import Cart from "../pages/Cart/Cart";
import StudentEdit from "../pages/Student/StudentEdit";
import RegisterNew from "../pages/Register/RegisterNew";
import RegisterExist from "../pages/Register/RegisterExist";
import PaymentHistory from "../pages/PaymentHistory/PaymentHistory";
import ItemView from "../pages/Item/ItemView";
import Inbox from "../pages/Inbox/Inbox";
import InboxView from "../pages/Inbox/InboxView";
import ScheduleList from "../pages/Schedule/ScheduleList";
import AttendanceView from "../pages/Student/Attendance/AttendanceView";
import BranchCourse from "../pages/Branch/BranchCourse";
import LoginAsUser from "../pages/LoginAsUser/LoginAsUser";
import CourseEdit from "../pages/Course/CourseEdit";
import ExploreCourseView from "../pages/Explore/ExploreCourseView";
import ExploreBranchView from "../pages/Explore/ExploreBranchView";
import Explore from "../pages/Explore/Explore";
import PublicRoutes from "./PublicRoute";
import School from "../pages/Home/School/School";
import AcademyBranch from "../pages/Home/Academy/AcademyBranch";
import CourseType from "../pages/Home/School/CourseType";
// import { academyRoutes } from './AcademyRoute';
import VoucherList from "../pages/Voucher/VoucherList";
import ActiveCourse from "../pages/ActiveCourse/ActiveCourse";
import Homework from "../pages/Homework/Homework";
import HomeworkSubmit from "../pages/Homework/HomeworkSubmit";
import AttendanceList from "../pages/Attendance/AttendanceList";
import PreEnroll from "../pages/PreEnroll/PreEnroll";
import Verify from "../pages/Activate/VerifyChild";
import RegisterParent from "../pages/Activate/RegisterParent";
import EventDetail from "../pages/Schedule/EventDetail";
import StudentReport from "../pages/StudentReport/StudentReport";
import StudentReportView from "../pages/StudentReport/StudentReportView";

const routes: RouteObject[] = [
  { path: "login", element: <Login /> },
  { path: "register", element: <Register /> },
  { path: "register-new", element: <RegisterNew /> },
  { path: "register-exist", element: <RegisterExist /> },
  { path: "reset-password", element: <ResetPassword /> },
  { path: "login-as-user", element: <LoginAsUser /> },
  { path: "activate/verify", element: <Verify /> },
  { path: "activate/register", element: <RegisterParent /> },

  // Public Routes - Accessible without authentication
  {
    path: "/",
    element: <PublicRoutes />,
    children: [
      { index: true, element: <Explore /> },
      {
        path: "explore",
        children: [
          { path: "course/:courseBranchId", element: <ExploreCourseView /> },
          { path: "branch/:branchId", element: <ExploreBranchView /> },
        ],
      },
    ],
  },

  {
    path: "/",
    loader: roleGuard,
  },
  // ...academyRoutes

  // Private Routes - Require authentication
  {
    path: "/",
    element: <PrivateRoutes />,
    children: [
      { index: true, element: <Explore /> },
      { path: "school", children: [{ index: true, element: <School /> }] },
      {
        path: "academy",
        children: [{ index: true, element: <AcademyBranch /> }],
      },
      {
        path: "profile",
        children: [
          { index: true, element: <Profile /> },
          { path: "edit", element: <EditProfile /> },
        ],
      },
      {
        path: "course",
        children: [
          { path: ":id", element: <CourseView /> },
          { path: ":id/edit", element: <CourseEdit /> },
        ],
      },
      { path: "item", children: [{ path: ":id", element: <ItemView /> }] },
      { path: "cart", children: [{ index: true, element: <Cart /> }] },
      {
        path: "children",
        children: [{ path: ":type/:id?", element: <StudentEdit /> }],
      },
      {
        path: "payment-history",
        children: [{ index: true, element: <PaymentHistory /> }],
      },
      {
        path: "inbox",
        children: [
          { index: true, element: <Inbox /> },
          { path: ":id", element: <InboxView /> },
        ],
      },
      {
        path: "schedule",
        children: [{ index: true, element: <ScheduleList /> }],
      },
      {
        path: "branch",
        children: [{ path: ":branchId", element: <BranchCourse /> }],
      },
      {
        path: "course-type",
        children: [{ path: ":courseTypeId", element: <CourseType /> }],
      },
      {
        path: "voucher",
        children: [{ index: true, element: <VoucherList /> }],
      },
      {
        path: "explore",
        children: [
          { path: "course/:courseBranchId", element: <ExploreCourseView /> },
          { path: "branch/:branchId", element: <ExploreBranchView /> },
        ],
      },
      {
        path: "active-course",
        children: [{ index: true, element: <ActiveCourse /> }],
      },
      {
        path: "homework",
        children: [
          { index: true, element: <Homework /> },
          { path: "submit/:homeworkId", element: <HomeworkSubmit /> },
        ],
      },
      {
        path: "student-report",
        children: [{ index: true, element: <StudentReport /> },
        { path: ":reportId", element: <StudentReportView /> }],
      },
      {
        path: "attendance",
        children: [
          { index: true, element: <AttendanceList /> },
          { path: ":attendanceId", element: <AttendanceView /> },
        ],
      },
      {
        path: "pre-enroll",
        children: [{ index: true, element: <PreEnroll /> }],
      },
      {
        path: "event",
        children: [{ path: ":eventId", element: <EventDetail /> }],
      },
      // { path: "schedule",
      //     children: [
      //         { index: true, element: <ScheduleView /> },
      //         { path: ":id", element: <AttendanceView /> },
      //     ],
      // },
    ],
  },
  { path: "*", element: <NotFound /> },
];

const router = createBrowserRouter(routes);

export default router;
